import { forwardRef } from "react";
import { Icon } from "@newsela/angelou";
import ThinArrowRightSvg from "./ThinArrowRight.svg.jsx";

const ThinArrowRight = forwardRef<SVGSVGElement, any>((props, ref) => {
  return <Icon ref={ref} SvgComponent={ThinArrowRightSvg} {...props} />;
});

ThinArrowRight.displayName = "ThinArrowRight";
export default ThinArrowRight;
